<template>
  <div class="collection-share-modal">
    <div class="mb-3">
      <input v-model="searchQuery" :placeholder="$t('general.search')" class="form-control"
             type="text" @input="onSearch">
    </div>
    <template v-for="(user, index) in filteredUsers">
      <div :key="index" class="d-flex align-items-center justify-content-between py-2">
        <div class="d-flex align-items-center">
          <img :alt="user.name + ' ' + user.surname" :src="user.photo_link"
               class="rounded-circle avatar-sm mr-3"/>
          <p class="mb-0">{{ user.name + ' ' + user.surname }}</p>
        </div>
        <div v-if="historyOnly">
          <button class="btn btn-secondary btn-sm" @click="removeUser(user.id)">
            <i class="uil-times"></i> {{ $t("general.remove") }}
          </button>
        </div>
        <template v-else>
          <div v-if="localSharedIds.includes(user.id)">
            <span class="text-success mr-2"><i class="uil-check"></i> {{ $t("collectionDetail.person_added") }}</span>
            <button class="btn btn-secondary btn-sm" @click="removeUser(user.id)">
              <i class="uil-times"></i> {{ $t("collectionDetail.cancel") }}
            </button>
          </div>
          <div v-else>
            <button class="btn btn-primary btn-sm" @click="addUser(user.id)">
              <i class="uil-user-plus"></i> {{ $t("collectionDetail.add") }}
            </button>
          </div>
        </template>
      </div>
      <hr :key="'hr-' + index" class="my-1"/>
    </template>
  </div>
</template>

<script>
export default {
  name: "CollectionShareModal",
  props: {
    users: {
      type: Array,
      default: () => []
    },
    sharedIds: {
      type: Array,
      default: () => []
    },
    historyOnly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      searchQuery: "",
      localSharedIds: [...this.sharedIds]
    };
  },
  computed: {
    filteredUsers() {
      let list = this.users;
      if (this.historyOnly) {
        list = list.filter(user => this.sharedIds.includes(user.id));
      }
      if (!this.searchQuery) return list;
      const query = this.searchQuery.toLowerCase();
      return list.filter(user => {
        const fullName = `${user.name} ${user.surname}`.toLowerCase();
        return fullName.includes(query);
      });
    }
  },
  watch: {
    sharedIds(val) {
      if (JSON.stringify(val) !== JSON.stringify(this.localSharedIds)) {
        this.localSharedIds = [...val];
      }
    },
    localSharedIds(val) {
      this.$emit("update:sharedIds", val);
    }
  },
  methods: {
    onSearch() {
      // filteredUsers computed handles filtering
    },
    addUser(userId) {
      this.localSharedIds.push(userId);
    },
    removeUser(userId) {
      this.localSharedIds.splice(this.localSharedIds.indexOf(userId), 1);
    }
  }
};
</script>
